import {get, post, put, _delete} from './Tools';

const getBancos = async () => {
try{
 const response = await get(`${process.env.REACT_APP_SERVER}bancos/bancos`);
  return response;
  } catch (error) {
    console.error('Error:', error);
  }
};

const getBancosOdoo = async () => {
  try {
    const response = await get(`${process.env.REACT_APP_SERVER}odoo_bancos/list`);
    return response;
  } catch (error) {
    console.error('Error:', error);
  }
};

export {getBancos, getBancosOdoo};